export default "__VITE_ASSET__BqfkEKP5__"